const Subtitle = ({children}) =>
    <h2 className="text-2xl mb-1 font-bold border-b-1 border-gray-600">
        {children}
    </h2>

export default Subtitle